// TradingView utility functions

export const getTradingViewUrl = (symbol, exchange = 'NSE') => {
  const formattedSymbol = `${exchange}%3A${symbol.replace('-EQ', '')}`
  return `https://www.tradingview.com/chart/?symbol=${formattedSymbol}`
}

export const openTradingView = (symbol, exchange = 'NSE') => {
  const url = getTradingViewUrl(symbol, exchange)
  window.open(url, '_blank', 'noopener,noreferrer')
}